// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerDIV {
    justify-content: space-between;
}

    .headerDIV > *, .kvDIV > * {
        align-self: center;
    }
`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/showDialog/showDialog.settings.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;IAEI;QACI,kBAAkB;IACtB","sourcesContent":[".headerDIV {\n    justify-content: space-between;\n}\n\n    .headerDIV > *, .kvDIV > * {\n        align-self: center;\n    }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
